import React from 'react';

export const InputCompletedContext = React.createContext({
    inputArr: [],
    inputCompleted: () => {},
    inputSelected: () => {}
});
